import wrapper, {
	ElementWrapper,
} from '@amzn/awsui-components-react-v3/polaris/test-utils/dom';

export function expectFieldLabel(wrapper, fieldSelector, labelText) {
	expect(
		wrapper.findFormField(fieldSelector).findLabel().getElement()
	).toHaveTextContent(labelText);
}

export function expectFieldError(wrapper, fieldSelector, errorText) {
	expect(
		wrapper.findFormField(fieldSelector).findError().getElement()
	).toHaveTextContent(errorText);
}

export function expectFieldErrorNotExists(wrapper, fieldSelector) {
	expect(wrapper.findFormField(fieldSelector).findError()).toBeNull();
}

export function expectFieldDescription(wrapper, fieldSelector, errorText) {
	expect(
		wrapper.findFormField(fieldSelector).findDescription().getElement()
	).toHaveTextContent(errorText);
}

export function setFieldInputValue(wrapper, fieldSelector, value) {
	wrapper
		.findFormField(fieldSelector)
		.findControl()
		.findInput()
		.setInputValue(value);
}

export function expectFieldInputValue(wrapper, fieldSelector, value) {
	expect(
		wrapper
			.findFormField(fieldSelector)
			.findControl()
			.findInput()
			.findNativeInput()
			.getElement().value
	).toEqual(value);
}

export function getFieldNativeInput(wrapper, fieldSelector) {
	return wrapper
		.findFormField(fieldSelector)
		.findControl()
		.findInput()
		.findNativeInput()
		.getElement();
}

export function setFieldTextAreaValue(wrapper, fieldSelector, value) {
	wrapper
		.findFormField(fieldSelector)
		.findControl()
		.findTextarea()
		.setTextareaValue(value);
}

export function expectFieldTextAreaValue(wrapper, fieldSelector, value) {
	expect(
		wrapper
			.findFormField(fieldSelector)
			.findControl()
			.findTextarea()
			.findNativeTextarea()
			.getElement().value
	).toEqual(value);
}

export function getFieldNativeTextArea(wrapper, fieldSelector) {
	return wrapper
		.findFormField(fieldSelector)
		.findControl()
		.findTextarea()
		.findNativeTextarea()
		.getElement();
}

export function expectPlaceHolder(element, placeHolderText) {
	expect(element).toHaveAttribute('placeholder', placeHolderText);
}

export async function expectFieldSelectBoxValue(wrapper, fieldSelector, value) {
	openFieldSelectBoxDropDown(wrapper, fieldSelector);
	expect(
		wrapper
			.findFormField(fieldSelector)
			.findControl()
			.findSelect()
			.findDropdown()
			.findSelectedOptions()[0]
			.findLabel()
			.getElement().textContent
	).toStrictEqual(value);
	closeFieldSelectBoxDropDown(wrapper, fieldSelector);
}

export async function openFieldSelectBoxDropDown(wrapper, fieldSelector) {
	return await wrapper
		.findFormField(fieldSelector)
		.findControl()
		.findSelect()
		.openDropdown();
}

export async function closeFieldSelectBoxDropDown(wrapper, fieldSelector) {
	return await wrapper
		.findFormField(fieldSelector)
		.findControl()
		.findSelect()
		.closeDropdown();
}

export async function expectFieldSelectBoxOptionsLength(
	wrapper,
	fieldSelector,
	length
) {
	openFieldSelectBoxDropDown(wrapper, fieldSelector);
	expect(
		wrapper
			.findFormField(fieldSelector)
			.findControl()
			.findSelect()
			.findDropdown()
			.findOptions().length
	).toStrictEqual(length);
	closeFieldSelectBoxDropDown(wrapper, fieldSelector);
}

export function expectFieldConstraintText(
	wrapper,
	fieldSelector,
	constraintText
) {
	expect(
		wrapper.findFormField(fieldSelector).findConstraint().getElement()
	).toHaveTextContent(constraintText);
}

export const getPolarisWrapper = (element?: HTMLElement) => {
	return wrapper(element ?? document.body) as ElementWrapper;
};

export const getSpinnerWrapper = (selector = '') => {
	return getPolarisWrapper().findSpinner(selector);
};

export const getGridWrapper = () => {
	return getPolarisWrapper().findGrid();
};

export const getAlertWrapper = () => {
	return getPolarisWrapper().findAlert();
};

export const getContentLayoutWrapper = (selector?) => {
	return getPolarisWrapper().findContentLayout(selector);
};

export const getButtonWrapper = (selector) => {
	return getPolarisWrapper().findButton(selector);
};

export const getHelpPanelWrapper = (selector?) => {
	return getPolarisWrapper().findHelpPanel(selector);
};

export const getSelectWrapper = () => {
	return getPolarisWrapper().findSelect();
};

export const getContainerWrapper = (selector?) => {
	return getPolarisWrapper().findContainer(selector);
};

export const getFlashbarWrapper = () => {
	return getPolarisWrapper().findFlashbar();
};

export const getHeaderWrapper = (selector) => {
	return getPolarisWrapper().findHeader(selector);
};

export const getPropertyFilterWrapper = () => {
	return getPolarisWrapper().findPropertyFilter();
};

export const getTableWrapper = () => {
	return getPolarisWrapper().findTable();
};

export const getModalWrapper = (selector) => {
	return getPolarisWrapper().findModal(selector);
};

export const getWizardWrapper = () => {
	return getPolarisWrapper().findWizard();
};

export const deepCopyTestVersion = (object) => {
	return JSON.parse(JSON.stringify(object));
};

export const generateTestId = (prefix: string, suffix: string): string => {
	return `${prefix}-${suffix}`;
};
